import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './DropdownTextInput.module.sass';
import TextInput from '../TextInput';

const DropdownTextInput = ({ val, onChange, classes = {}, options = [] }) => {
  const [isSearching, setIsSearching] = useState(false);

  const inputClass = typeof classes === 'string' ? classes : classes.input;
  const inputClasses = cn(inputClass, styles.schoolInput, { [styles.dropdownInputOpen]: isSearching && Boolean(val) });

  const focusHandler = () => setIsSearching(true);
  const blurHandler = () => setIsSearching(false);
  const optionsHandler = e => onChange(e.target.innerText);

  const optionsHtml = options
    .filter(option => option.toLowerCase().includes(val.toLowerCase()))
    .map(option =>
      <div
        className={styles.dropdownItem}
        key={option}
        onMouseDown={optionsHandler}
      >
        {option}
      </div>
    );

  return (
    <div className={styles.dropdownInputContainer} onBlur={blurHandler}>
      <TextInput
        val={val}
        onChange={e => onChange(e.target.value)}
        label='School Name'
        placeholder='Start typing...'
        onFocus={focusHandler}
        classes={inputClasses}
        fullWidth
      />
      {isSearching && Boolean(val) && <div className={cn(styles.dropdown, classes.dropdown)}>{optionsHtml}</div>}
    </div>
  );
};

DropdownTextInput.propTypes = {
  val: PropTypes.oneOfType([
    PropTypes.string,
  ]),
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      dropdownContainer: PropTypes.string,
      container: PropTypes.string,
      label: PropTypes.string,
      input: PropTypes.string,
    }),
  ]),
  options: PropTypes.arrayOf(PropTypes.string),
};

export default DropdownTextInput;
